module.exports = __webpack_public_path__ + "f26c6f1a374d9dd5da579ff6c3f8d5a6.svg";